// A project link is a locator, never an authentication credential.
export default function useHandoff(s) {
  return { url: window.location.origin + '/studio/mobile?project=' + encodeURIComponent(s.current.id) };
}
